import React, { ReactNode } from 'react';

import { useCurrentUser } from '@portals/api/ui';
import { DashboardLayout } from '@portals/framework';

import { ExternalUserAlert } from '../ExternalUserAlert';

interface OrganizationDashboardLayoutProps {
  children: ReactNode;
}

export function OrganizationDashboardLayout({
  children,
}: OrganizationDashboardLayoutProps) {
  const currentUser = useCurrentUser();

  if (!currentUser.isFetched || !currentUser.data?.is_external)
    return <DashboardLayout>{children}</DashboardLayout>;

  return (
    <>
      <ExternalUserAlert />
      <DashboardLayout>{children}</DashboardLayout>
    </>
  );
}
